<div class="bcg">
    <div class="d-flex justify-content-between custom-container mt-3">
        <nav class="custom-nav">
            <ol class="breadcrumb m-2">
                <li class="breadcrumb-item"  style="cursor: pointer;" (click)="gotoDashboard()">Dashboard </li>
                <li class="breadcrumb-item active"  style="cursor: context-menu;"  aria-current="page">User Management</li>
            </ol>
        </nav>
        <div class="dropdown-container">
            <app-dropdown [options]="cities" [(ngModel)]="selectedCity" placeholder="All branches" optionLabel="name"
                [showClear]="true"
                [style]="{'width': '250px', 'height': '35px', 'display': 'flex', 'align-items': 'center', 'border-radius': '10px'}"></app-dropdown>
        </div>
    </div>
    <div class="page_responsive card mt-4">
        <div class="card-body">
            <div class="row">
                <span class="col-6 card-title title_header ">Edit User</span>
            </div>
            <div class="d-flex justify-content-between">
                <div>

                    <p style="margin-top: 25px; font-size: 13px;">Lorem ipsum dolar sit (one line description of the service)</p>
                </div>
            </div>

        </div>
    </div>

    <div class="page_responsive card mt-3">
        <div class="card-body">
            <div class="row">
                <span class="col-6 card-title title_header">John Doe</span>
            </div>
            <div class="d-flex justify-content-end me-2">
                <i class='bx bx-trash-alt'></i>
            </div>
            <div class="row ">
                <div class="col-3">
                    <div>
                        <h5 class="label-field">First name<span style="color: #ED455D;">*</span></h5>
                        <input [(ngModel)]="firstName" class="p-2 input-field-p" pInputText type="text"
                            placeholder="John" required minlength="2" maxlength="50" name="firstName">
                    </div>
                </div>
                <div class="col-3">
                    <div style="margin-left: 50px;">
                        <h5 class="label-field">Last name <span style="color: #ED455D;">*</span></h5>
                        <input [(ngModel)]="lastName" class="p-2 input-field-p" pInputText type="text" placeholder="Doe"
                            required minlength="2" maxlength="50" name="lastName">
                    </div>
                </div>
                <div class="col-3">
                    <div style="margin-left: 100px;">
                        <h5 class="label-field">Email <span style="color: #ED455D;">*</span></h5>
                        <input [(ngModel)]="email" class="p-2 input-field-p" pInputText type="email"
                            placeholder="johndoe@gmail.com" required email name="email">
                    </div>
                </div>
            </div>

            <div class="row ">
                <div class="col-3">
                    <div>
                        <h5 class="label-field-bottom">Mobile Number<span style="color: #ED455D;">*</span></h5>
                        <input [(ngModel)]="mobile" class="p-2 input-field-p" pInputText type="text"
                            placeholder="+91 8169432694" required minlength="2" maxlength="50" name="firstName">
                    </div>
                </div>
                <div class="col-3">
                    <div style="margin-left: 50px;">
                        <h5 class="label-field-bottom ">Password<span style="color: #ED455D;">*</span></h5>
                        <input [(ngModel)]="password" class="p-2 input-field-p" pInputText type="text"
                            placeholder="*******" required minlength="2" maxlength="50" name="lastName">
                    </div>
                </div>
                <div class="col-3">
                    <div style="margin-left: 100px;">
                        <h5 class="label-field-bottom ">Confirm Password<span style="color: #ED455D;">*</span></h5>
                        <input [(ngModel)]="confirmpassword" class="p-2 input-field-p" pInputText type="email"
                            placeholder="********" required email name="email">
                    </div>
                </div>
            </div>

            <div class="row ">
                <div class="col-3">
                    <div class="dropdown-container-role">
                        <h5 class="label-field-bottom ">Role<span style="color: #ED455D;">*</span></h5>
                        <app-dropdown [options]="cities" [(ngModel)]="selectedCity1" placeholder="Select"
                            optionLabel="name" [showClear]="true"
                            [style]="{'width': '320.07px', 'height': '35px', 'display': 'flex', 'align-items': 'center', 'border-radius': '10px'}"></app-dropdown>
                    </div>
                </div>
                <div class="col-3">
                    <div class="dropdown-container-branch" style="margin-left: 50px;">
                        <h5 class="label-field-bottom ">Branch<span style="color: #ED455D;">*</span></h5>
                        <app-dropdown [options]="cities" [(ngModel)]="selectedCity2" placeholder="Select"
                            optionLabel="name" [showClear]="true"
                            [style]="{'width': '320.07px', 'height': '35px', 'display': 'flex', 'align-items': 'center', 'border-radius': '10px'}"></app-dropdown>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end me-4 mb-3">
            <div>
                <button type="button"  style="font-size: 15px;" [routerLink]="'/doqfy/userManagement/form'" class="btn btn-outline-custom me-4 ">Cancel</button>
            </div>


            <div>
                <button class="button-style" (click)="savePersonalDetails()" type="button">Save</button>
            </div>
        </div>
    </div>

</div>